import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchFooterData = createAsyncThunk("footer/fetchFooterData", async ({ lang = "en" }) => {
  const response = await axios.post(
    "https://milkys.bytesway.io/api/footer",
    {
      lang,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
});

const footerSlice = createSlice({
  name: "footer",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchFooterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFooterData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFooterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default footerSlice.reducer;
